import { render, staticRenderFns } from "./BatchSettings.vue?vue&type=template&id=7f517352&scoped=true&"
import script from "./BatchSettings.vue?vue&type=script&lang=ts&"
export * from "./BatchSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f517352",
  null
  
)

export default component.exports